module.exports = __webpack_public_path__ + "img/cg_fireflies.73378c73.jpg";